var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Slidebar',{attrs:{"extraLarge":true},on:{"closeMe":_vm.closeSlidebar}},[_c('h4',[_vm._v(_vm._s(_vm.name))]),(_vm.id)?_c('GradeScale',{attrs:{"id":_vm.id,"edit":false}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }